<template>
  <div class="notificationBox">
    <div class="title">
      <h2>系统信息</h2>
    </div>
    <div class="search">
      <el-input 
        placeholder="请输入内容" 
        v-model="searchInput" 
        :class="['searchInput', isDark ? 'darkInput' : '']"
        @change="searchChange"
        @keyup.enter.native="searchChange"
      >
        <div slot="suffix" class="searchIcon">
          <i class="el-icon-search"></i>
        </div> 
      </el-input>
    </div>
    <div class="talksBox scrollStyle">
      <div v-for="(item, index) in msgList" :key="index">
        <Msg 
          :news="item" 
          :isHoverAction="true" 
          msgType="noti" 
          @show="showNotification"
          @del="deleteNotification"
        >
        </Msg>
      </div>
    </div>
    <!-- 信息详情 -->
    <el-dialog
      :visible.sync="dialogDtlVisible"
      title="信息详情"
      width="50%"
      :fullscreen="false"
      destroy-on-close
      class="mobile-dialog"
    >
      信息详情
    </el-dialog>
  </div>
</template>

<script>
import Msg from '../+components/Msg';
import {mapState} from 'vuex';

export default {
  name: 'Notification',
  components: {Msg},
  props: {},
  data () {
    return {
      searchInput: '',
      dialogDtlVisible: false,
      msgList: [
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
        {
          avatarIcon: 'ti-bell',
          textTitle: '账户余额不足',
          textContent: '您的账号余额不足，为了不影响使用请及时充值',
          timeText: '03:41 PM',
        },
      ],
    }
  },
  computed: {
    ...mapState('comAbout', ['isDark']),
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    // 搜索消息
    searchChange() {
      console.log('搜索', this.searchInput);
    },
    // 查看详情
    showNotification() {
      this.dialogDtlVisible = true;
    },
    // 删除消息
    deleteNotification() {
      console.log('删除消息');
    },
  }
}
</script>

<style scoped lang="less">
.notificationBox {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  .title {
    line-height: 24px;
    margin: 16px 0 8px;
    height: 22px;
    h2 {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .search {
    margin: 4px 0 16px;
    height: 55px;
    // :global(.el-input__inner) {
    //   background-color: #ebeff4;
    //   border: 0;
    //   border-radius: 8px;
    //   height: 55px;
    //   line-height: 55px;
    //   font-size: 13px;
    //   padding: 0 20px;
    // }
    .searchIcon {
      height: 55px;
      width: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 20px;
      }
    }
  }
  .talksBox {
    height: calc(100% - 22px - 55px);
    flex: 1;
    overflow-y: auto;
    padding-right: 3px;
    position: relative;

    // /* 针对整个滚动条 */ 
    // &::-webkit-scrollbar {  
    //   width: 3px; /* 滚动条的宽度 */  
    // }
    // /* 滚动条轨道 */  
    // &::-webkit-scrollbar-track {  
    //   // background: #f1f7fe; /* 滚动条轨道的背景色 */  
    //   background: transparent;
    // } 
    // /* 滚动条滑块 */  
    // &::-webkit-scrollbar-thumb {  
    //   // background: #f1f7fe; /* 滚动条滑块的颜色 */  
    //   background: transparent;
    //   border-radius: 5px; /* 滑块边缘的圆角 */  
    // }  
    // &:hover::-webkit-scrollbar-thumb {
    //   background: rgb(238, 238, 238); 
    // }
  }
}
</style>
